import { useQueryClient } from '@tanstack/react-query';
import { FC, useState } from 'react';
import styled from 'styled-components';

import { SwitchLabel, SwitchSlider } from '@/components/Switch';
import Text from '@/components/Text';
import useToasts from '@/hooks/useToasts';
import { api } from '@/utils/api';

const Box = styled.div`
  padding: 16px 24px;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 32px;
  gap: 6px;
`;

interface Props {
  translationId: number;
  applyTapForSoungImg: boolean;
}

const GraphicElementsForm: FC<Props> = ({
  translationId,
  applyTapForSoungImg,
}) => {
  const toasts = useToasts();
  const queryClient = useQueryClient();
  const [active, setActive] = useState(applyTapForSoungImg);
  const [isLoading, setIsLoading] = useState(false);

  const onChange = async () => {
    const initialState = active;

    const toastId = toasts.create('loading', 'Saving...');

    setIsLoading(true);
    setActive(!initialState);

    try {
      toasts.success(toastId, 'Saved');

      await api.put(`/v1/distribution/ml-translations/${translationId}`, {
        settings: {
          applyTapForSoungImg: !initialState,
        },
      });

      await queryClient.invalidateQueries([
        'ml_translations',
        {
          id: translationId.toString(),
        },
      ]);
    } catch (_) {
      setActive(initialState);
      toasts.success(toastId, 'Error!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <Description>
        <Text $type="smallBold">“Tap for sound” file</Text>
        <Text $color="gray" $type="smallNormal">
          The specified language file will be applied to the final video result
        </Text>
      </Description>
      <SwitchLabel>
        <input
          id={'tapForSoundToggle'}
          type="checkbox"
          disabled={isLoading}
          checked={active}
          onChange={onChange}
        />
        <SwitchSlider $disabled={isLoading} />
      </SwitchLabel>
    </Box>
  );
};

export default GraphicElementsForm;
